import { render, staticRenderFns } from "./sw.vue?vue&type=template&id=508a102e&scoped=true"
import script from "./sw.vue?vue&type=script&lang=js"
export * from "./sw.vue?vue&type=script&lang=js"
import style0 from "./sw.vue?vue&type=style&index=0&id=508a102e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a102e",
  null
  
)

export default component.exports